import { Box, IconButton, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { PageNav } from "@/components/Events/EventsTable.tsx";
import type { PortalSourcesPage, SourcesFilters, SourcesSort } from "@/types";
import { buildSourcesRange, SOURCES_SORTS } from "@/utils/sourcesFilters.ts";
import * as copy from "@/utils/vulnerabilityCopy.ts";

export default function SourcesToolbar({ filters, onChange, page, onPage, data, isFetching }: {
  readonly filters: SourcesFilters;
  readonly onChange: (filters: SourcesFilters) => void;
  readonly page: number;
  readonly onPage: (page: number) => void;
  readonly data: PortalSourcesPage | undefined;
  readonly isFetching: boolean;
}) {
  const range = buildSourcesRange(page, data);
  const descending = filters.order === "desc";
  const orderLabel = descending ? copy.ORDER_DESC : copy.ORDER_ASC;
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 1, px: 2, py: 1.5,
      borderBottom: 1, borderColor: "divider" }}>
      <Typography variant="body2" color="text.secondary">{copy.showingLabel(range.from, range.to, range.total)}</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TextField select size="small" label={copy.SORT_LABEL} value={filters.sort} sx={{ minWidth: 160 }}
          onChange={(event) => onChange({ ...filters, sort: event.target.value as SourcesSort })}>
          {SOURCES_SORTS.map((sort) => <MenuItem key={sort} value={sort}>{copy.SORTS[sort]}</MenuItem>)}
        </TextField>
        <Tooltip title={orderLabel}>
          <IconButton size="small" aria-label={orderLabel}
            onClick={() => onChange({ ...filters, order: descending ? "asc" : "desc" })}>
            {descending ? <ArrowDownwardIcon fontSize="small" /> : <ArrowUpwardIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
        <PageNav page={page} pageCount={range.pageCount} onPrev={() => onPage(page - 1)} onNext={() => onPage(page + 1)}
          isFetching={isFetching} />
      </Box>
    </Box>
  );
}
